// =============================================================================
// src/chrome/copilot-sidebar/tactic-card-markup.ts
// Builder de markup de um card tatico "Específicas desta vista".
//
// Proveniencia: porte fiel de assets/unified-app.js linhas 2722-2740
//   (CopilotTactics.cardHTML). String concatenada mantida com as MESMAS tags,
//   classes, atributos data-priority e icones Tabler para paridade exata com o
//   markup estatico das táticas prioritárias (unified.html 188-237).
// =============================================================================

import type { TacticPriority, ViewTacticCard } from './tactic-cards-by-section';

/** Rotulo exibido por prioridade (cardHTML: { alta:'Alta', media:'Média', baixa:'Baixa' }). */
const TACTIC_PRIORITY_LABEL: Record<TacticPriority, string> = {
  alta: 'Alta',
  media: 'Média',
  baixa: 'Baixa',
};

/**
 * Monta o HTML de um card tatico especifico de vista.
 *
 * @example
 *   buildTacticCardMarkup({ priority:'alta', category:'Coligação', confidence:79,
 *     desc:'…', impact:'…', cta:'Ativar tática' })
 */
export function buildTacticCardMarkup(card: ViewTacticCard): string {
  const priorityLabel = TACTIC_PRIORITY_LABEL[card.priority];
  const ctaClass = card.ctaGhost
    ? 'copilot-tactic-cta copilot-tactic-cta--ghost'
    : 'copilot-tactic-cta';
  return (
    '' +
    '<article class="copilot-tactic-card" data-priority="' + card.priority + '">' +
    '<div class="copilot-tactic-head">' +
    '<span class="copilot-tactic-priority copilot-tactic-priority--' + card.priority + '">' + priorityLabel + '</span>' +
    '<span class="copilot-tactic-tag">' + card.category + '</span>' +
    '<span class="copilot-tactic-confidence">' + card.confidence + '%</span>' +
    '</div>' +
    '<p class="copilot-tactic-desc">' + card.desc + '</p>' +
    '<div class="copilot-tactic-impact">' +
    '<i class="ti ti-trending-up"></i><span>' + card.impact + '</span>' +
    '</div>' +
    '<button class="' + ctaClass + '" type="button">' +
    '<span>' + card.cta + '</span><i class="ti ti-arrow-right"></i>' +
    '</button>' +
    '</article>'
  );
}
